<div class="content-card">
    <div class="card-inner">
        <p-fluid>
            <div class="font-semibold text-xl mb-4 module-name">
                Test Scenarios
            </div>

            <!-- Filter Bar -->
            <div class="flex items-center mb-4 pl-2.5">
                <div class="flex items-center gap-6 flex-1">
                    <div class="flex items-center gap-3">
                        <label class="font-medium whitespace-nowrap">Client:</label>
                        <div class="w-80">
                            <p-select [options]="viewModel.clientFilterOptions()" optionLabel="label" optionValue="value"
                                [ngModel]="viewModel.selectedClientFilter()" [filter]="true"
                                placeholder="Select Client..."
                                [showClear]="!!viewModel.selectedClientFilter() && viewModel.selectedClientFilter() !== 'default'"
                                [disabled]="viewModel.isClientDropdownDisabled()"
                                (onChange)="viewModel.filterByClient($event.value)"
                                (onClear)="viewModel.clearClientFilter()"
                                styleClass="w-full">
                            </p-select>
                        </div>
                    </div>
                    <div class="flex items-center gap-3">
                        <label class="font-medium whitespace-nowrap">Test Type:</label>
                        <div class="w-80">
                            <p-multiselect
                                [options]="viewModel.testTypeFilterOptions()"
                                [ngModel]="viewModel.filterTestType()"
                                [filter]="true"
                                placeholder="Filter by Test Type"
                                [showClear]="viewModel.filterTestType()?.length > 0"
                                [disabled]="!viewModel.selectedClientFilter()"
                                (onChange)="viewModel.filterByTestType($event.value)"
                                (onClear)="viewModel.clearTestTypeFilter()"
                                display="chip"
                                [maxSelectedLabels]="2"
                                optionLabel="label"
                                optionValue="value"
                                styleClass="w-full">
                            </p-multiselect>
                        </div>
                    </div>
                </div>
                <div class="ml-auto flex items-center gap-3">
                    <div class="search-container">
                        <p-iconfield iconPosition="left">
                            <p-inputicon styleClass="cursor-pointer" (click)="searchInput.focus()">
                                <i class="pi pi-search cursor-pointer"></i>
                            </p-inputicon>
                            <input #searchInput pInputText type="text" (input)="viewModel.onSearchInput($event)"
                                placeholder="Search..." [disabled]="!viewModel.selectedClientFilter()" />
                        </p-iconfield>
                        @if (viewModel.searchTerm) {
                            <button class="search-clear" (click)="viewModel.clearSearch(); searchInput.value = ''">
                                <i class="pi pi-times"></i>
                            </button>
                        }
                    </div>
                    @if (viewModel.isSystemUser()) {
                        <p-button label="Add" icon="pi pi-plus" severity="info"
                            (click)="viewModel.openNew()" [disabled]="!viewModel.selectedClientFilter()" />
                    }
                </div>
            </div>

            <!-- No Client Selected State -->
            @if (!viewModel.selectedClientFilter()) {
                <div class="no-data-card">
                    <h3>Select a Client</h3>
                    <p>Choose a client from the dropdown to view test scenarios.</p>
                </div>
            }

            <!-- Has Client Selected, No Scenarios -->
            @if (viewModel.selectedClientFilter() && viewModel.totalScenarios() === 0 && viewModel.faTabCounts().length === 0) {
                <div class="no-data-card">
                    <h3>No Scenarios Found</h3>
                    <p>No test scenarios exist for this selection.@if (viewModel.isSystemUser()) { Click "Add" to create one.}</p>
                </div>
            }

            <!-- Has Client Selected, With Scenarios -->
            @if (viewModel.selectedClientFilter() && (viewModel.totalScenarios() > 0 || viewModel.faTabCounts().length > 0)) {
                <!-- Functional Area Tabs -->
                @if (viewModel.faTabCounts().length > 0) {
                    <div class="fa-tabs-container" #faTabsContainer>
                        <div class="fa-tabs">
                            <button class="fa-tab" [class.active]="viewModel.activeFaTab() === 'all'"
                                (click)="viewModel.selectFaTab('all')">
                                All <span class="fa-tab-count">{{viewModel.allScenariosCount()}}</span>
                            </button>
                            @for (tab of viewModel.visibleTabs; track tab.id) {
                                <button class="fa-tab" [class.active]="viewModel.activeFaTab() === tab.id"
                                    (click)="viewModel.selectFaTab(tab.id)">
                                    {{tab.name}} <span class="fa-tab-count">{{tab.count}}</span>
                                </button>
                            }
                        </div>
                        <div class="fa-tabs-measure" aria-hidden="true" #faTabsMeasure>
                            <button class="fa-tab">All <span class="fa-tab-count">{{viewModel.allScenariosCount()}}</span></button>
                            @for (tab of viewModel.faTabCounts(); track tab.id) {
                                <button class="fa-tab">{{tab.name}} <span class="fa-tab-count">{{tab.count}}</span></button>
                            }
                            <button class="fa-more-btn">More <span class="more-count">+99</span> ▾</button>
                        </div>
                        @if (viewModel.overflowTabs.length > 0) {
                            <button class="fa-more-btn" (click)="viewModel.toggleMoreDropdown()">
                                More <span class="more-count">+{{viewModel.overflowTabs.length}}</span> ▾
                            </button>
                            @if (viewModel.showMoreDropdown()) {
                                <div class="fa-more-dropdown">
                                    <div class="fa-more-header">
                                        <span class="fa-more-title">More Functional Areas</span>
                                        <span class="fa-more-counter">{{viewModel.overflowTabs.length}}</span>
                                    </div>
                                    <div class="fa-more-search-wrap">
                                        <i class="pi pi-search fa-more-search-icon"></i>
                                        <input class="fa-more-search" placeholder="Search areas..."
                                            [(ngModel)]="viewModel.moreDropdownSearch" />
                                    </div>
                                    <div class="fa-more-list">
                                        @for (tab of viewModel.filteredOverflowTabs; track tab.id) {
                                            <div class="fa-more-item" (click)="viewModel.selectFaTab(tab.id); viewModel.closeMoreDropdown()"
                                                [class.active]="viewModel.activeFaTab() === tab.id">
                                                <span class="badge-fa" [ngClass]="viewModel.getFaBadgeClass(tab.name)">{{tab.name}}</span>
                                                <span class="mi-count">{{tab.count}}</span>
                                            </div>
                                        }
                                        @if (viewModel.filteredOverflowTabs.length === 0) {
                                            <div class="fa-more-empty">No areas match</div>
                                        }
                                    </div>
                                </div>
                            }
                        }
                    </div>
                }

                <p-table #dt [value]="viewModel.scenarios() || []" [rows]="viewModel.pageSize" [paginator]="true"
                    [lazy]="true" (onLazyLoad)="viewModel.onLazyLoad($event)" [totalRecords]="viewModel.totalScenarios()"
                    [tableStyle]="{ 'min-width': '60rem' }" [rowHover]="true" dataKey="id"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} scenarios"
                    [showCurrentPageReport]="true" [rowsPerPageOptions]="[10, 20, 30]">

                    <ng-template #header>
                        <tr>
                            <th pSortableColumn="functionalAreaId" style="min-width:14rem">
                                Functional Area
                                <p-sortIcon field="functionalAreaId" />
                            </th>
                            <th pSortableColumn="testTypeId" style="min-width:12rem">
                                Test Type
                                <p-sortIcon field="testTypeId" />
                            </th>
                            <th pSortableColumn="scenarioId" style="min-width:12rem">
                                Scenario ID
                                <p-sortIcon field="scenarioId" />
                            </th>
                            <th pSortableColumn="scenarioName" style="min-width:16rem">
                                Scenario Name
                                <p-sortIcon field="scenarioName" />
                            </th>
                            <th style="width: 16rem">Action</th>
                        </tr>
                    </ng-template>

                    <ng-template #body let-scenario>
                        <tr>
                            <td>
                                <span class="badge-fa" [ngClass]="viewModel.getFaBadgeClass(scenario.functionalArea?.name)">
                                    {{scenario.functionalArea?.name || '-'}}
                                </span>
                            </td>
                            <td>{{ scenario.testType?.referenceValue || '-' }}</td>
                            <td>
                                <span class="sc-link" (click)="viewModel.viewScenario(scenario)">
                                    {{ scenario.scenarioId }}
                                </span>
                            </td>
                            <td>{{ scenario.scenarioName || '-' }}</td>
                            <td>
                                <span class="inline-flex items-center">
                                    <p-button icon="pi pi-plus" severity="secondary" [rounded]="true" [outlined]="true" [raised]="true" styleClass="quick-actions-btn" (click)="quickActions.toggle($event)" pTooltip="Quick Actions" tooltipPosition="top" class="mr-2" />
                                    <p-popover #quickActions [dismissable]="true" [appendTo]="'body'">
                                        <div class="flex flex-col gap-2 p-2">
                                            <p-button label="Recording" icon="pi pi-video" (click)="viewModel.navigateToRecordingCreate(scenario); quickActions.hide()"></p-button>
                                            <p-button label="Conversational AI" icon="pi pi-comments" (click)="viewModel.captureSteps(scenario); quickActions.hide()"></p-button>
                                        </div>
                                    </p-popover>
                                </span>
                                <p-button icon="pi pi-file-excel" severity="secondary" [rounded]="true" [outlined]="true"
                                    [raised]="true" (click)="viewModel.exportScenarioSteps(scenario)" pTooltip="Export to Excel"
                                    tooltipPosition="top" class="mr-2" />
                                <p-button icon="pi pi-pencil" severity="info" [rounded]="true" [outlined]="true"
                                    [raised]="true" (click)="viewModel.editScenario(scenario)" pTooltip="Edit"
                                    tooltipPosition="top" class="mr-2" />
                                <p-button icon="pi pi-trash" severity="danger" [rounded]="true" [outlined]="true"
                                    [raised]="true" (click)="viewModel.deleteScenario(scenario)" pTooltip="Delete"
                                    tooltipPosition="top" />
                            </td>
                        </tr>
                    </ng-template>

                    <ng-template #emptymessage>
                        <tr>
                            <td colspan="5" class="noData">No scenarios found.</td>
                        </tr>
                    </ng-template>
                </p-table>
            }
        </p-fluid>

        <!-- Scenario Dialog -->
        <p-dialog [(visible)]="viewModel.scenarioDialog" [appendTo]="'body'" [style]="{ width: '900px' }"
            [header]="viewModel.isViewMode ? 'Scenario Details' : (viewModel.isEditMode ? 'Edit Scenario' : 'Create Scenario')"
            [modal]="true" [dismissableMask]="false" [blockScroll]="true" [draggable]="false"
            styleClass="module-name scenario-dialog" (onHide)="viewModel.hideDialog()">

            <ng-template #content>
                <form [formGroup]="viewModel.form" class="p-fluid" autocomplete="off">
                    <div class="grid grid-cols-2 gap-4">
                        <div class="field">
                            <label for="functional_area" class="block font-medium mb-2">Functional Area <span class="text-red-500">*</span></label>
                            <p-select formControlName="functionalAreaId" [options]="viewModel.getFunctionAreaOptions()"
                                optionLabel="value" optionValue="id" placeholder="Select Functional Area"
                                [appendTo]="'body'" class="w-full"
                                (onChange)="viewModel.onFunctionalAreaChange($event.value)"></p-select>
                            @if (viewModel.form.get('functionalAreaId')?.invalid && viewModel.form.get('functionalAreaId')?.touched && !viewModel.isViewMode) {
                                <small class="text-red-500">Functional Area is required.</small>
                            }
                        </div>
                        <div class="field">
                            <label for="test_type" class="block font-medium mb-2">Test Type <span class="text-red-500">*</span></label>
                            <p-select formControlName="testTypeId" [options]="viewModel.getTypeTestOptions()"
                                optionLabel="value" optionValue="id" placeholder="Select Test Type" [appendTo]="'body'"
                                class="w-full"></p-select>
                            @if (viewModel.form.get('testTypeId')?.invalid && viewModel.form.get('testTypeId')?.touched && !viewModel.isViewMode) {
                                <small class="text-red-500">Test Type is required.</small>
                            }
                        </div>
                    </div>

                    <div class="grid grid-cols-2 gap-4">
                        <div class="field">
                            <label for="scenarioId" class="block font-medium mb-2">Scenario Id <span class="text-red-500">*</span></label>
                            <input id="scenarioId" type="text" pInputText formControlName="scenarioId"
                                placeholder="Enter scenario id" class="w-full" [readonly]="viewModel.isViewMode" />
                            @if (viewModel.form.get('scenarioId')?.invalid && viewModel.form.get('scenarioId')?.touched && !viewModel.isViewMode) {
                                <small class="text-red-500">Scenario ID is required.</small>
                            }
                        </div>
                        <div class="field">
                            <label for="scenarioName" class="block font-medium mb-2">Scenario Name <span class="text-red-500">*</span></label>
                            <input id="scenarioName" type="text" pInputText formControlName="scenarioName"
                                placeholder="Enter scenario name" class="w-full" [readonly]="viewModel.isViewMode" />
                            @if (viewModel.form.get('scenarioName')?.invalid && viewModel.form.get('scenarioName')?.touched && !viewModel.isViewMode) {
                                <small class="text-red-500">Scenario name is required.</small>
                            }
                        </div>
                    </div>

                    <div class="field">
                        <label for="scenarioDescription" class="block font-medium mb-2">Description</label>
                        <textarea id="scenarioDescription" pTextarea formControlName="scenarioDescription"
                            placeholder="Enter scenario description" rows="3" class="w-full"
                            [readonly]="viewModel.isViewMode"></textarea>
                    </div>

                    <!-- Preconditions Section -->
                    @if (!viewModel.isViewMode) {
                        <div class="field">
                            <p-accordion [multiple]="false" [(value)]="viewModel.expandPreconditions">
                                <p-accordion-panel [value]="0">
                                    <p-accordion-header>Preconditions (Optional)</p-accordion-header>
                                    <p-accordion-content>
                                    <div class="p-fluid">
                                        <div class="grid grid-cols-2 gap-4">
                                            <div class="field">
                                                <label for="authProfile" class="block font-medium mb-2">Authentication Profile</label>
                                                <p-select
                                                    id="authProfile"
                                                    formControlName="selectedProfileGroup"
                                                    [options]="viewModel.profileGroupOptions()"
                                                    optionLabel="label"
                                                    optionValue="value"
                                                    placeholder="Select Authentication Profile (Optional)"
                                                    [appendTo]="'body'"
                                                    [showClear]="true"
                                                    [filter]="true"
                                                    class="w-full">
                                                </p-select>
                                                <small class="text-500 block mt-1">
                                                    Authentication profile group for this test. Select a functional area first to load profiles.
                                                </small>
                                            </div>
                                            <div class="field">
                                                <label for="startScreen" class="block font-medium mb-2">Start Screen</label>
                                                <p-select
                                                    id="startScreen"
                                                    formControlName="screenId"
                                                    [options]="viewModel.screenMasters()"
                                                    optionLabel="name"
                                                    optionValue="id"
                                                    placeholder="Select Start Screen (Optional)"
                                                    [appendTo]="'body'"
                                                    [showClear]="true"
                                                    [filter]="true"
                                                    class="w-full">
                                                </p-select>
                                                <small class="text-500 block mt-1">
                                                    Expected screen before test starts
                                                </small>
                                            </div>
                                        </div>
                                        <div class="field">
                                            <label for="sessionPolicy" class="block font-medium mb-2">Session Policy</label>
                                            <p-select
                                                id="sessionPolicy"
                                                formControlName="sessionPolicy"
                                                [options]="[
                                                    { label: 'Reuse Session', value: 'REUSE' },
                                                    { label: 'Fresh Session', value: 'FRESH' }
                                                ]"
                                                optionLabel="label"
                                                optionValue="value"
                                                placeholder="Select Session Policy (Default: REUSE)"
                                                [appendTo]="'body'"
                                                [showClear]="true"
                                                class="w-full">
                                            </p-select>
                                            <small class="text-500 block mt-1">
                                                REUSE: Share session across scenarios | FRESH: New browser session
                                            </small>
                                        </div>
                                        <div class="field flex align-items-center gap-2">
                                            <p-checkbox
                                                formControlName="skipIfSatisfied"
                                                [binary]="true"
                                                inputId="skipIfSatisfied">
                                            </p-checkbox>
                                            <label for="skipIfSatisfied" class="mb-0">Skip preconditions if already satisfied</label>
                                        </div>
                                    </div>
                                    </p-accordion-content>
                                </p-accordion-panel>
                            </p-accordion>
                        </div>
                    }
                </form>
            </ng-template>

            <ng-template #footer>
                @if (viewModel.isViewMode) {
                    <p-button label="Close" icon="pi pi-times" severity="warn"
                        (click)="viewModel.hideDialog()"></p-button>
                }
                @if (!viewModel.isViewMode) {
                    <p-button label="Cancel" icon="pi pi-times" severity="warn"
                        (click)="viewModel.hideDialog()"></p-button>
                    <p-button [label]="viewModel.isEditMode ? 'Update' : 'Submit'" icon="pi pi-check" severity="success"
                        (click)="viewModel.saveScenario()"></p-button>
                }
            </ng-template>
        </p-dialog>

        <p-confirmdialog [style]="{ width: '450px', maxWidth: '90vw' }" [baseZIndex]="10000" [appendTo]="'body'"
            styleClass="custom-confirm-dialog" />
    </div>
</div>
